import DataTableView from "@components/views/datatable-view";
import LoadingButton from "@components/ui-components/loading-button";
import UpsertSegment from "./upsert";
import usePageChange from "@hooks/use-page-change";
import useSegments from "./use-segments";

const Segments = () => {
    const {
        data: { segments = [], pagination = {} },
        loading,
        columns,
        setQueryParams,
        handleModalConfig,
        modalConfig,
        getSegments
    } = useSegments();

    /* A custom hook that is used to handle the pagination. */
    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });
    return (
        <>
            <DataTableView
                moduleName={"Segments"}
                breadcrumbItems={{
                    items: [
                        {
                            title : "Segments",
                            active: true
                        }
                    ]
                }}
                loading={loading}
                tableProps={{
                    data: segments,
                    columns,
                    handlePageChange,
                    handlePerRowsChange,
                    pagination
                }}
                actionItems={
                    <LoadingButton
                        color="primary"
                        icon="plus"
                        testId="add-segment"
                        onClick={() => handleModalConfig({})}
                        subject="segments"
                        text="Add Segment"/>
                }/>
            <UpsertSegment
                getSegments={getSegments}
                modalConfig={modalConfig}
                handleModal={handleModalConfig}/>
        </>
    );
};

export default Segments;
